module.exports = __webpack_public_path__ + "img/black.aed877d8.png";